var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import classNames from 'classnames';
var STYLE_NAMESPACE = 'vcp-text';
export var STYLE_TEXT_BOLD = 'vcp-text-bold';
export var STYLE_TEXT_ITALIC = 'vcp-text-italic';
export var STYLE_TEXT_MULTILINE = 'vcp-text-multiline';
var Text = function (_a) {
    var _b = _a.fontStyle, fontStyle = _b === void 0 ? 'regular' : _b, color = _a.color, children = _a.children, className = _a.className, id = _a.id, textDecoration = _a.textDecoration, isBold = _a.isBold, setRef = _a.setRef, ariaProps = __rest(_a, ["fontStyle", "color", "children", "className", "id", "textDecoration", "isBold", "setRef"]);
    return React.useMemo(function () {
        var _a;
        var compoundClassName = classNames(STYLE_NAMESPACE, fontStyle, className, color, (_a = {},
            _a["".concat(STYLE_NAMESPACE, "__text_decoration_").concat(textDecoration)] = textDecoration,
            _a["".concat(STYLE_NAMESPACE, "__is_bold")] = isBold,
            _a));
        switch (fontStyle) {
            case 'h1': {
                return (React.createElement("h1", __assign({ id: id, className: compoundClassName }, ariaProps, { ref: setRef }), children));
            }
            case 'h2': {
                return (React.createElement("h2", __assign({ id: id, className: compoundClassName }, ariaProps, { ref: setRef }), children));
            }
            case 'h3': {
                return (React.createElement("h3", __assign({ id: id, className: compoundClassName }, ariaProps, { ref: setRef }), children));
            }
            case 'h4': {
                return (React.createElement("h4", __assign({ id: id, className: compoundClassName }, ariaProps, { ref: setRef }), children));
            }
            case 'h5': {
                return (React.createElement("h5", __assign({ id: id, className: compoundClassName }, ariaProps, { ref: setRef }), children));
            }
            case 'h6': {
                return (React.createElement("h6", __assign({ id: id, className: compoundClassName }, ariaProps, { ref: setRef }), children));
            }
            case 'subtitle':
            case 'regular':
            case 'large':
            case 'medium':
            case 'small':
            case 'xs':
            case 'label-large':
            case 'label-medium':
            case 'label-small':
            case 'label-xs': {
                return (React.createElement("p", __assign({ id: id, className: compoundClassName }, ariaProps, { ref: setRef }), children));
            }
            default:
                return (React.createElement("span", __assign({ id: id, className: compoundClassName }, ariaProps, { ref: setRef }), children));
        }
    }, [fontStyle, children, className, color, id]);
};
export var Label = function (_a) {
    var children = _a.children, className = _a.className, disabled = _a.disabled, color = _a.color, _b = _a.size, size = _b === void 0 ? 'small' : _b;
    return (React.createElement("label", { className: classNames('vcp-text', className, color, { disabled: disabled }, size) }, children));
};
export var InputError = function (_a) {
    var children = _a.children;
    return (React.createElement(Text, { fontStyle: "medium", color: "destructive" }, children));
};
export var InputSuccess = function (_a) {
    var children = _a.children;
    return (React.createElement(Text, { fontStyle: "medium", color: "success" }, children));
};
export var InputHelper = function (_a) {
    var children = _a.children, className = _a.className, disabled = _a.disabled;
    return (React.createElement(Text, { fontStyle: "medium", className: classNames("".concat(disabled ? 'secondary3' : 'secondary'), className) }, children));
};
export default Text;
